export const runAll =
  <T = unknown>(...fns: (((...args: T[]) => void) | undefined)[]) =>
  (...args: T[]): void =>
    fns.forEach((fn) => fn?.(...args));
